import React, { useCallback, useEffect, useState } from "react";
import axiosInstance from "../../config/axiosConfig";
import { BadgeEstado, ESTADOS_MENSAJE, fechaHora } from "./enviosUi";

/**
 * Estado de la notificación por WhatsApp de cada auxiliar en un período (columna de las tablas
 * de Honorarios y Honorarios Adelanto). tipo: "adelanto" | "fm".
 * Devuelve { porAuxiliar: { [auxiliar_id]: estado }, recargar }.
 */
export const useEstadosWhatsapp = (periodo, tipo) => {
    const [porAuxiliar, setPorAuxiliar] = useState({});

    const recargar = useCallback(async () => {
        if (!periodo) return;
        try {
            const { data } = await axiosInstance.get("/envios/honorarios/estado", { params: { periodo, tipo } });
            setPorAuxiliar(data?.data?.notificados || {});
        } catch {
            // Sin motor de envíos (o sin permisos) la columna simplemente queda vacía.
            setPorAuxiliar({});
        }
    }, [periodo, tipo]);

    useEffect(() => {
        recargar();
    }, [recargar]);

    return { porAuxiliar, recargar };
};

/** Texto para buscar/filtrar la columna (la celda solo se dibuja, la fila no trae el estado). */
export const textoEstadoWhatsapp = (estado) => {
    if (!estado) return "Sin notificar";
    const label = ESTADOS_MENSAJE[estado.estado]?.label || estado.estado;
    return [label, estado.estado, estado.demo && "demo", estado.error_detalle].filter(Boolean).join(" ");
};

/** Celda: estado + fecha del último hito (leído, entregado, enviado o encolado). */
export const EstadoWhatsappHonorarios = ({ estado }) => {
    if (!estado) return <span className="text-muted">—</span>;

    const [hito, fecha] = estado.leido ? ["Leído", estado.leido]
        : estado.entregado ? ["Entregado", estado.entregado]
        : estado.enviado ? ["Enviado", estado.enviado]
        : ["Encolado", estado.creado];

    return (
        <div className="lh-sm" title={estado.error_detalle || `${hito} ${fechaHora(fecha)}`}>
            <BadgeEstado estado={estado.estado} />
            {estado.demo && <span className="badge bg-warning text-dark ms-1" title="Salió al número de pruebas: no cuenta como notificada">demo</span>}
            <div className="small text-muted text-nowrap">{fechaHora(fecha)}</div>
            {estado.estado === "fallido" && estado.error_detalle && (
                <div className="small text-danger text-truncate" style={{ maxWidth: 180 }}>{estado.error_detalle}</div>
            )}
        </div>
    );
};
